// User members form behaviour

import $ from 'jquery';

var $users_array = [];
var $duplicates_array = [];

var form = document.getElementById('edit-field-user-admins-wrapper');

if (form !== null) {

  const findDuplicates = expanded => {
    $users_array = [];
    $duplicates_array = [];
    
    $('table[id^="field-user-admins-values"]').find('input[id*=target-id]').each(function() {
      $users_array.push($(this).val());
    });

    $('table[id^="field-user-editors-values"]').find('input[id*=target-id]').each(function() {
      $users_array.push($(this).val());
    });

    $('table[id^="field-user-members-values"]').find('input[id*=target-id]').each(function() {
      $users_array.push($(this).val());
    });

    $users_array = $users_array.filter(function(e) {
      return e;
    });

    var $uniqueElements = new Set();
    $users_array.forEach($user => {
      if ($uniqueElements.has($user)) {
        $duplicates_array.push($user);
      } else {
        $uniqueElements.add($user);
      }
    });
  };

  const markFields = expanded => {
    $.each($duplicates_array, function(index, value) {
      $('table[id^="field-user-admins-values"]').find('input[id*=target-id]').each(function() {
        if ($(this).val() == value) {
          $(this).css('box-shadow', '0 0 0 .2rem red');
        }
      });

      $('table[id^="field-user-editors-values"]').find('input[id*=target-id]').each(function() {
        if ($(this).val() == value) {
          $(this).css('box-shadow', '0 0 0 .2rem red');
        }
      });

      $('table[id^="field-user-members-values"]').find('input[id*=target-id]').each(function() {
        if ($(this).val() == value) {
          $(this).css('box-shadow', '0 0 0 .2rem red');
        }
      });

      $('#duplicate-error').html('Sama käyttäjä on liitetty useaan kenttään.');
    });
  };

  const resetCSS = expanded => {
    $('table[id^="field-user-members-values"]').find('input[id*=target-id]').each(function() {
      $(this).removeAttr('style');
    });

    $('table[id^="field-user-editors-values"]').find('input[id*=target-id]').each(function() {
      $(this).removeAttr('style');
    });

    $('table[id^="field-user-admins-values"]').find('input[id*=target-id]').each(function() {
      $(this).removeAttr('style');
    });

    $('#duplicate-error').html('');
  }

  $(document).ready(function() {
    $('#block-particle-content').prepend('<p id="duplicate-error" style="margin-top:1rem;color:red;"></p>');
    resetCSS();
    findDuplicates();
    markFields();
  });

  $(document).on('change', function() {
    resetCSS();
    findDuplicates();
    markFields();
  });

  $('table[id^="field-user-admins-values"]').on('change', 'input', function () {
    resetCSS();
    findDuplicates();
    markFields();
  });

  $('table[id^="field-user-editors-values"]').on('change', 'input', function () {
    resetCSS();
    addMessage();
    findDuplicates();
    markFields();
  });

  $('table[id^="field-user-members-values"]').on('change', 'input', function () {
    resetCSS();
    findDuplicates();
    markFields();
  });

  const observer = new MutationObserver((mutationsList, observer) => {
    for(const mutation of mutationsList) {
      resetCSS();
      findDuplicates();
      markFields();
    }
  });

  observer.observe(form, {
    childList: true,
    subtree: true
  });

}